module.exports = __webpack_public_path__ + "media/video-mobile.85d7c904.mp4";